/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkContactAlias} from '../api'

export const useMutationUnlinkContactAlias = createReactQueryMutationHook('unlinkContactAlias', unlinkContactAlias)
